import { Container, AppBar, Toolbar, IconButton, Typography, Avatar, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { ArrowBackOutlined, KeyboardArrowRightOutlined } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { createNewTheme } from '../functions/utils';
import * as React from 'react';

import '@fontsource/roboto/400.css';
import { SpacerMely } from '../components/DesignSystem/SpacerMely';

function PerfilLoja() {

  const state = useLocation().state;
  const page = state ? state.page : 'home';
  const [colorPrimary, setColorPrimary] = useState(state ? state.colorPrimary : "217, 217, 217");
  const [colorSecondary, setColorSecondary] = useState(state ? state.colorSecondary : "217, 217, 217");
  const [colorTertiary, setColorTertiary] = useState(state ? state.colorTertiary : "217, 217, 217");
  const [urlBase, setUrlBase] = useState("");
  const [nome, setNome] = useState('');
  const [isMesa, setIsMesa] = useState(false);
  const [onlyMenu, setOnlyMenu] = useState(false);
  const navigate = useNavigate();

  const handleBack = () => {
    const numeroMesa = localStorage.getItem('nM');
    if (numeroMesa) {
      navigate(`/?nm=${btoa(numeroMesa)}`, { replace: true, state: { page: page } })
    } else {
      navigate("/", { replace: true, state: { page: page } })
    }
  };
  
  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      handleBack();
    };

    window.history.pushState(null, '', window.location.href);

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const handleFidelidade = () => {
    navigate('/fidelidade', { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } });
  };

  const handleInformacoes = () => {
    navigate('/informacoes', { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } });
  };

  const handleAvaliacoes = () => {
    navigate('/avaliacoes-loja', { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } });
  };

  useEffect(() => {

    const onlyMenu = localStorage.getItem('eNbM') === "true";
    if (onlyMenu) {
      setOnlyMenu(onlyMenu)
    }

    const mainName = localStorage.getItem('Mn');
    document.title = mainName;
    const urlBase = localStorage.getItem('UBs');
    const favicon = document.querySelector('link[rel="icon"]');
    favicon.href = `${urlBase.replaceAll("/api", "")}/imagens/logo-store.png?${new Date().getTime()}`;

    if (colorPrimary) {
      setColorPrimary(localStorage.getItem("clPmr"))
      setColorSecondary(localStorage.getItem("clScr"))
      setColorTertiary(localStorage.getItem("clTcr"))
    }

    setNome(mainName)
    const url = localStorage.getItem('UBs');
    setUrlBase(url)

    const numeroMesa = localStorage.getItem('nM');
    if (numeroMesa) {
      setIsMesa(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeProvider theme={createNewTheme(colorPrimary, colorSecondary, colorTertiary)}>
      <Container>

        <AppBar position="absolute" style={{ backgroundColor: `rgba(${colorPrimary})`, color: "#FFF", fontWeight: "bold", boxShadow: "none", fontFamily: "roboto" }}>
          <Toolbar>
            <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }} style={{ color: "#FFF" }} onClick={handleBack}>
              <ArrowBackOutlined />
            </IconButton>
            Perfil da loja
          </Toolbar>
        </AppBar>

        <SpacerMely height={83} />

        <>
          <Avatar src={`${urlBase.replaceAll("/api", "")}/imagens/logo-store.png?${new Date().getTime()}`} style={{ margin: "auto", width: "48px", height: "48px" }} />

          <SpacerMely height={12} />

          <Typography style={{ fontSize: "16px", color: "#1B1B1B", textAlign: "center", fontWeight: "bold" }}>
            {nome}
          </Typography>

          <SpacerMely height={30} />

          <List>
            <ListItem disablePadding divider={true}>
              <ListItemButton>
                <ListItemText primary="Informações" onClick={handleInformacoes} />
              </ListItemButton>
              <KeyboardArrowRightOutlined></KeyboardArrowRightOutlined>
            </ListItem>
            {!onlyMenu && (
              <ListItem disablePadding divider={true}>
                <ListItemButton>
                  <ListItemText primary="Avaliações da loja" onClick={handleAvaliacoes} />
                </ListItemButton>
                <KeyboardArrowRightOutlined></KeyboardArrowRightOutlined>
              </ListItem>
            )}
            {!isMesa && !onlyMenu && (
              <ListItem disablePadding divider={true}>
                <ListItemButton onClick={handleFidelidade}>
                  <ListItemText primary="Programa Fidelidade" />
                </ListItemButton>
                <KeyboardArrowRightOutlined></KeyboardArrowRightOutlined>
              </ListItem>
            )}
          </List>
        </>

        <SpacerMely height={100} />

      </Container>
    </ThemeProvider>
  );
}

export default PerfilLoja;